import type { ReceiptTemplate } from '../schema';

export const dominosTemplate: ReceiptTemplate = {
  id: 'dominos',
  name: "Domino's Receipt",
  brand: "DOMINO'S",
  description: 'Pizza delivery receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'dom-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/dominos.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #8472',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dom-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER #127847\nDELIVERY',
        fontSize: 14,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'dom-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '01/04/26 18:42  ONLINE ORDER\nDriver: JAMES S.',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'dom-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'dom-item-1', name: 'LG PEPPERONI PIZZA', quantity: '1', price: '15.99'},
          { id: 'dom-item-2', name: 'MED CHEESE PIZZA', quantity: '1', price: '11.99'},
          { id: 'dom-item-3', name: 'BREADSTICKS', quantity: '1', price: '5.99'},
          { id: 'dom-item-4', name: '2L COKE', quantity: '1', price: '3.49'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dom-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        labelAlignment: 'left',
        lines: [
          { id: 'dom-subtotal', label: 'Subtotal', value: '37.46', isBold: false, isLarge: false },
          { id: 'dom-delivery', label: 'Delivery Fee', value: '4.99', isBold: false, isLarge: false },
          { id: 'dom-tax', label: 'Tax', value: '3.77', isBold: false, isLarge: false },
          { id: 'dom-tip', label: 'Driver Tip', value: '5.00', isBold: false, isLarge: false },
          { id: 'dom-total', label: 'TOTAL', value: '51.22', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'dom-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'dom-card', label: 'VISA', value: '************4144' },
          { id: 'dom-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'dom-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '8472127847',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dom-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER ONLINE: DOMINOS.COM\nEARN FREE PIZZA WITH PIECE OF THE PIE',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

